import type { ProjectsSliceState } from './projects.types'

export const createInitialProjectsState = (): ProjectsSliceState => ({
  projects: [],
  activeProjectId: null,
  loadingProjects: false,
  projectsError: null,
  creatingProject: false,
  createProjectError: null,
  reorderingProjects: false,
  reorderingBoardsProjectId: null,
})
